import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'custom-input-text',
  templateUrl: './custom-input-text.component.html',
  styleUrls: ['./custom-input-text.component.scss'],
})
export class CustomInputTextComponent implements OnInit {
  @Input() label: string;
  @Input() id: string;
  @Input() placeholder: string;
  @Input() disabled: boolean;
  @Input() model;
  @Input() required: boolean = false;
  @Input() margin: string;
  @Input () errorMessage;
  @Input () maxLength;
  @Output() valueChange = new EventEmitter<any>();
  @Output() blur = new EventEmitter<any>();
  @Output() serchbuttonclick= new EventEmitter<any>();
  @Input() image=''
  @Input() suffix:boolean=false;
  constructor() {
    //Constructor
  }

  ngOnInit(): void {
    //onInit
  }

  onAppend(event) {
    this.valueChange.emit(event.value);
  }

  onBlur(event){
    this.blur.emit(event.value);
  }
  serchIcon(){
    this.serchbuttonclick.emit();

  }
}
